module.exports = __webpack_public_path__ + "static/karriere2-0ecd615ac582b33c7d89be088fe6196b.jpg";